import { Spinner, type SpinnerSize } from "./Spinner";

export interface LoadingProps {
  label?: string;
  size?: SpinnerSize;
  className?: string;
  minHeight?: number | string;
}

/**
 * Zentrierte Voll-Flächen-Ladeanzeige (Spinner + optionales Label).
 * Ersetzt zentrierte Ring-Divs in Panels/Sektionen und Route-Loader.
 * Route-Loader: <Loading className="min-h-[60vh]" label="…" />
 */
export function Loading({ label, size = "lg", className = "", minHeight = 180 }: LoadingProps) {
  return (
    <div
      role="status"
      className={`flex w-full flex-col items-center justify-center gap-3 text-content-2 ${className}`}
      style={{ minHeight }}
    >
      <Spinner size={size} />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}
